<template>
  <div class="tooltip_container">
    <div class="content_container">
      <div class="tooltip_color_indicator" :style="{'background': indicatorColor }"></div>
      <div class="tooltip_label">{{ label }}</div>
      <div class="tooltip_value">{{ value.toFixed(2) + unitText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartToolTip',
  props: {
    indicatorColor: {
      type: String,
      default: '#123456'
    },
    label: {
      type: String,
      default: 'ラベル'
    },
    value: {
      type: Number,
      default: 0
    },
    unitText: {
      type: String,
      default: ''
    }
  }
  
}
</script>

<style scoped>
.tooltip_container {
  background: #FFFFFF;
  border: 1px solid rgba(52, 58, 63, 0.3);
  border-radius: 12px;
  pointer-events: none;
  display: inline-flex;
  padding: 4px 5px;
  /* position: absolute;
  transform: translate(-50%, 0); */
  /* transition: all .1s ease; */
}

.content_container {
  margin: 0px;
  display: flex;
  justify-content: center;
}

.tooltip_color_indicator {
  background: #123456;
  border-color: #123456;
  border-width: 2px;
  margin-right: 10px;
  height: 30px;
  width: 4px;
  display: flex;
  border-radius: 3px;
}

.tooltip_label {
  background: #ededed;
  margin-right: 10px;
  padding: 5px 10px;
  border-radius: 16px;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-family: 'SF Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #343A3F;
}

.tooltip_value {
  display: flex;
  font-family: 'SF Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  color: #4d4d4d;
}


</style>